<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?(viewFlag?'查看服务据点':'编辑服务据点'):'新增服务据点'" :visible.sync="dialog" @close="unShowClick()" width="35%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="服务据点名称" prop="name" :label-width="formLabelWidth">
					<el-input :disabled='viewFlag' style="width: 100%;" v-model="addBody.name" placeholder="请输入服务据点名称"></el-input>
				</el-form-item>
				<el-form-item label="服务据点电话" :label-width="formLabelWidth">
					<el-input :disabled='viewFlag' type='number' style="width: 100%;" v-model="addBody.phone" placeholder="仅支持输入数字"></el-input>
				</el-form-item>
				<el-form-item label="服务据点地址" prop="address" :label-width="formLabelWidth">
					<el-input :disabled='viewFlag' style="width: 100%;" v-model="addBody.address" placeholder="请输入服务据点地址"></el-input>
				</el-form-item>
				<el-form-item label="权重" prop="weight" :label-width="formLabelWidth">
					<el-input :disabled='viewFlag' style="width: 100%;" type='number' v-model="addBody.weight" placeholder="请输入大于0的数字"></el-input>
					<div style="color: #999;">*权重数字越大排序越靠前</div>
				</el-form-item>
				
			</el-form>
			<div slot="footer" class="dialog-footer" v-if="!viewFlag">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="updateServiceLocation('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		addServiceLocation,
		updateServiceLocation,
		getServiceLocationDetail
	} from '@/api/views'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					name: '',
					phone: "",
					address: "",
					weight: '',
					uuid: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}, ],
					phone: [{
						required: true,
						message: '请输入服务据点电话',
						trigger: 'blur'
					}, { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }],
					address: [{
						required: true,
						message: '请输入地址',
						trigger: 'blur'
					}, ],
					weight: [{
						required: true,
						message: '请输入权重',
						trigger: 'blur'
					}, {
						// 匹配大于0的数字（包括整数和小数）
						pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
						message: '必须输入大于0的数字',
						trigger: ['blur', 'change']
					}],
				},
				weightList: [],
				weight: '',
				isEdit: false,
				lmList: [{
						id: 1,
						name: '用户'
					},
					{
						id: 2,
						name: '管理员'
					},
				],
				viewFlag:false
			}
		},
		mounted() {},
		methods: {
			setViewFlag(viewFlag){
				this.viewFlag = viewFlag
			},
			validateweight(weight) {
				const lengthValid = weight.length >= 8;
				const hasUpperCase = /[A-Z]/.test(weight);
				const hasLowerCase = /[a-z]/.test(weight);
				const hasNumber = /\d/.test(weight);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(weight);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			updateServiceLocation(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().updateServiceLocation()
						} else {
							this.network().addServiceLocation()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					addServiceLocation: async () => {
						const {
							status,
							data
						} = await addServiceLocation({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					updateServiceLocation: async () => {
						const {
							status
						} = await updateServiceLocation({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getServiceLocationDetail: async (uuid) => {
						const {
							data,
							status
						} = await getServiceLocationDetail({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.images = []
				if (val.uuid) {
					this.isEdit = true;
					this.addBody.uuid = val.uuid
					this.network().getServiceLocationDetail(val.uuid)
				} else {
					this.isEdit = false
					this.addBody.name = ''
					this.addBody.phone = ''
					this.addBody.address = ''
					this.addBody.weight = ''
					this.addBody.uuid = ''
				}
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>